<template>
    <div
        data-bs-toggle="modal" data-bs-target="#infoModal"
        @click="toggleInfoModal()"
    >
        <i
            ref="ffToggle"
            class="cursor-pointer fa-regular fa-circle-question d-inline-block ms-lg-2"
        ></i>
    </div>
</template>

<script>
    export default {
        props: ['homeDelivery'],
        methods: {
            toggleInfoModal() {
                var heading = '';
                var text = '';

                if(this.homeDelivery == true) {
                    heading = 'Mail order';
                    text = '<p>Delivered to your home or work in 3-5 working days. Delivery cost calculated at the basket.</p>';
                }
                else {
                    heading = 'Fully fitted';
                    text = '<p>Fully fitted price includes VAT, delivery, fitting and balancing.</p>';
                }

                this.emitter.emit('openInfoModal', {heading: heading, text: text});
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>